import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import _ from 'lodash';

const MockDataModel = ({
  showModalForMockData,
  toggle,
  currentUserParams,
  handleMockValueChange,
  collectionMapping,
  bodyCollectionMapping,
  urlKeyMapping,
  bodyDataFrom,
  jsonObjNeedleKeyMapping,
  requestDataJsonType,
  handleMockCollectionValueChange,
  handleMockValueSubmit,
}) => {
  let bodyDataMapping = {};
  if (
    ['collectionItem', 'NON_PERSISTENT_COLLECTION'].includes(bodyDataFrom) &&
    ['FORM_DATA', 'FORM_URL_ENCODED'].includes(requestDataJsonType)
  ) {
    bodyDataMapping = bodyCollectionMapping;
  } else if (
    ['collectionItem', 'NON_PERSISTENT_COLLECTION'].includes(bodyDataFrom) &&
    !['CUSTOM', 'FORM_DATA', 'FORM_URL_ENCODED'].includes(requestDataJsonType)
  ) {
    bodyDataMapping = collectionMapping;
  } else if (
    ['RAW_JSON', 'collectionItem'].includes(bodyDataFrom) &&
    ['DEFAULT', 'CUSTOM'].includes(requestDataJsonType)
  ) {
    bodyDataMapping = jsonObjNeedleKeyMapping;
  }

  bodyDataMapping = _.merge(_.keyBy(bodyDataMapping, 'key'), _.keyBy(urlKeyMapping, 'key'));
  bodyDataMapping = _.values(bodyDataMapping);

  return (
    <Modal size="lg" isOpen={showModalForMockData} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} className="border-bottom">
        <strong>Mock Request Data</strong>
      </ModalHeader>
      <ModalBody>
        <div className="row pt-2 pb-2">
          <div className="col-md-12 col-sm-12">
            <strong>Provide mock data for current user field to send request.</strong>
            <table className="table table-stripped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {currentUserParams.map(param => {
                  if (param.key && param.value) {
                    return (
                      <tr key={param.key}>
                        <td>{param.key}</td>
                        <td>
                          <input
                            type="text"
                            name={param.key}
                            className="form-control form-control-input"
                            onChange={handleMockValueChange}
                          />
                        </td>
                      </tr>
                    );
                  }
                })}
                {bodyDataMapping.map(param => {
                  if (param.key && param.value) {
                    return (
                      <tr key={param.key}>
                        <td>{param.key}</td>
                        <td>
                          <input
                            type="text"
                            name={param.key}
                            className="form-control form-control-input"
                            onChange={handleMockCollectionValueChange}
                          />
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="col-12 text-right">
          <button type="button" className="btn btn-theme-submit" onClick={handleMockValueSubmit}>
            <i className={`wb ${drapcodeIcon('send-request')}`}></i>&nbsp;Send Request
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default MockDataModel;
